import { render, staticRenderFns } from "./ManageAftercareList.vue?vue&type=template&id=64ec421e&scoped=true&"
import script from "./ManageAftercareList.vue?vue&type=script&lang=js&"
export * from "./ManageAftercareList.vue?vue&type=script&lang=js&"
import style0 from "./ManageAftercareList.vue?vue&type=style&index=0&id=64ec421e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec421e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VDataTable})
